import type { ParteDoPagamento, StatusPedido } from './dominio';

// Busca "/" do painel (etapa 3): nº do pedido, telefone, nome e rua numa função só do banco
// (buscar_no_balcao, supabase/migrations/*_balcao_busca.sql).

export interface ClienteAchado {
  id: string;
  nome: string;
  telefone: string;
  pedidos: number;
  ultimoPedidoEm: string | null;
}

export interface PedidoAchado {
  id: string;
  numero: number;
  status: StatusPedido;
  criadoEm: string;
  /** Dia operacional do pedido ("2026-10-22"), pela virada e o fuso da loja. */
  dia: string;
  itens: string;
  totalCentavos: number;
  pagamentos: ParteDoPagamento[];
  entregadorNome: string | null;
}

export type ResultadoDaBusca =
  | { tipo: 'pedido'; pedido: PedidoAchado; cliente: ClienteAchado }
  | { tipo: 'cliente'; cliente: ClienteAchado }
  | {
      tipo: 'endereco';
      cliente: ClienteAchado;
      endereco: { id: string; rua: string; bairro: string | null };
    };

/** Texto com menos que isto não busca (só número busca a partir de 1 dígito). */
export const MIN_BUSCA = 2;

/**
 * Espelho de v_so_numero em buscar_no_balcao: "1055", "#1055", "nº 1055", "(27) 98111", "+55 27 98111".
 * Só número procura o pedido pelo nº e o cliente pelo telefone, nunca nome nem rua.
 */
export function ehBuscaPorNumero(texto: string): boolean {
  return /^(n[ºo°]?\.?\s*|#)?[(+]?\s*[0-9][0-9 ()+-]*$/i.test(texto.trim());
}
